module.exports = __webpack_public_path__ + "static/media/MenuIconThumbnails.58d775af.jpg";